// This will avoid using lazy-loading if any page content updated and apply updates immediately instead.
export default {
  onUpdate: registration => {
    registration.unregister().then(() => {
      console.info('service worker on updated state')
      window.location.reload()
    })
  },
  onSuccess: registration => {
    console.info('service worker on success state')
    console.log(registration)
  },
}
